"use strict";
/*
 * Created on 18. 7. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var BigNumberRangeValidator_1 = require("../../../core/model/data-dictionary/validators/BigNumberRangeValidator");

var ConstraintTypeEnum_1 = require("./ConstraintTypeEnum");

var SimpleConstraint_1 = require("./SimpleConstraint");
/**
 * Targeted average margin for new prices.
 *
 * @author Radek Beran
 */


var AverageMargin =
/*#__PURE__*/
function (_SimpleConstraint_1$S) {
  _inherits(AverageMargin, _SimpleConstraint_1$S);

  /**
   * @param value
   */
  function AverageMargin(value) {
    var _this;

    _classCallCheck(this, AverageMargin);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AverageMargin).call(this, value));
    _this.value = value;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(AverageMargin, [{
    key: "getType",
    value: function getType() {
      return ConstraintTypeEnum_1.ConstraintTypeEnum.AverageMargin;
    }
  }]);

  return AverageMargin;
}(SimpleConstraint_1.SimpleConstraint);

exports.AverageMargin = AverageMargin;
AverageMargin.MIN_VALUE = 0;
AverageMargin.MAX_VALUE = 100; // tslint:disable-next-line:member-ordering

AverageMargin.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SimpleConstraint_1.SimpleConstraint.name);
  return {
    value: builder.bigNum('value', new BigNumberRangeValidator_1.BigNumberRangeValidator(AverageMargin.MIN_VALUE, AverageMargin.MAX_VALUE))
  };
}();